import type { Collection } from 'state/utils/types';

import type { RegulationData, TileData } from '../model';

export type ReloadedTileData = TileData & RegulationData;
export type ReloadedTilesMap = Collection<ReloadedTileData>;

export type ReloadedState = {
  isLoading: boolean;
  tiles: ReloadedTilesMap;
};

export const initialReloadedState: ReloadedState = {
  isLoading: false,
  tiles: {},
};
